import React from 'react';
import { connect } from 'react-redux';
import { CloseIconContainer, ActivityContainer } from '../style';
import { Text } from '../../../UI/Text';
import { FormModalContainer, FormModalContent } from './style';
import { EmptyState } from '../../../Containers/WithEmptyState/EmptyState';
import { ActivityFactoryComponent } from '../../../Containers/ActivityList/ActivityList';
import { NoWorkoutsFoundState } from '../../BannerEmptyStats/BannerEmptyStats';
import { Column } from '../../../Layouts';
import { StyledButton } from '../../forms/style';
import { OuterIndend } from '../../../UI/Indends';
import { SearchInput } from '../AddMemberModal/style';
import debounce from 'lodash.debounce';
import { Loading } from '../../../Containers/WithLoading/Loading';
import InfiniteWorkoutsScroll from '../../InfiniteScroll/InfiniteWorkoutsScroll';
import { SearchWorkoutsActionCreators } from '../../../../Store/ActionCreators/SearchWorkoutsActionCreators';

class AddWorkoutPlanModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searchFilter: '',
        };
    }

    componentDidMount() {
        this.props.getSearchWorkouts(this.state.searchFilter);
    }

    attachWorkout = workout => {
        this.props.addWorkout(workout);
    };

    handleInputChange = e => {
        this.setState({ searchFilter: e.target.value }, () => this.searchWithDelay());
    };

    searchWithDelay = debounce(() => {
        this.props.getSearchWorkouts(this.state.searchFilter);
    }, 250);

    render() {
        const { onClose, loading, workouts, metric } = this.props;
        const { searchFilter } = this.state;
        const areWorkoutsEmpty = workouts.length === 0;

        return (
            <FormModalContainer>
                <FormModalContent>
                    <Text alignCenter marginBottom={'30px'} fontSize={22} weight={'bold'}>
                        Add Workout
                    </Text>
                    <CloseIconContainer onClick={onClose}>
                        <i className="fas fa-times" />
                    </CloseIconContainer>

                    <div style={{ width: '350px' }}>
                        <SearchInput onChange={this.handleInputChange} placeholder={'Search workouts'} />
                    </div>

                    <ActivityContainer id={'add-workout-modal-scroll'}>
                        <Loading isLoading={loading}>
                            <EmptyState isEmpty={areWorkoutsEmpty} emptyState={NoWorkoutsFoundState}>
                                <InfiniteWorkoutsScroll
                                    scrollableTarget={'add-workout-modal-scroll'}
                                    filter={searchFilter}
                                >
                                    {workouts.map((act, index) => (
                                        <AddWorkoutCard
                                            size={'large'}
                                            activity={act}
                                            metric={metric}
                                            onClick={this.attachWorkout}
                                            key={index}
                                        />
                                    ))}
                                </InfiniteWorkoutsScroll>
                            </EmptyState>
                        </Loading>
                    </ActivityContainer>
                </FormModalContent>
            </FormModalContainer>
        );
    }
}

const AddWorkoutCard = ({ activity, metric, onClick, size }) => (
    <Column width={'100%'} alignCenter>
        <div style={{ cursor: 'pointer' }} onClick={() => onClick(activity)}>
            <ActivityFactoryComponent
                withoutHeader={true}
                size={size}
                key={activity.id}
                metric={metric}
                {...activity}
                hasLink={false}
            />
        </div>
        <StyledButton onClick={() => onClick(activity)}>ADD WORKOUT</StyledButton>
        <OuterIndend />
    </Column>
);

const mapStateToProps = ({ workoutSearch: { loading, workouts }, user: { currentUserPreferences } }) => ({
    loading,
    workouts,
    metric: currentUserPreferences.metric,
});

const mapDispatchToProps = dispatch => ({
    getSearchWorkouts: filter => dispatch(SearchWorkoutsActionCreators.getAllWorkout(filter)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AddWorkoutPlanModal);



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/AddWorkoutPlanModal/AddWorkoutPlanModal.js